import reducer from './virtualNumbersReducer';
import actions from './virtualNumbersActions';
import selectors from './virtualNumbersSelectors';

export default {
  reducer,
  actions,
  selectors,
};
